export const LanguageDataZhChs = {
  AssociationValue: "关联值",
  AssociationField: "关联字段",
  String: "文本",
  Text: "备注",
  Integer: "整数",
  Decimal: "浮点数字",
  Boolean: "布尔型",
  Date: "日期",
  Time: "时间",
  DateTime: "日期时间",
  Binary: "二进制",
  UnifiedDataType: "业务字段",
  None: "无",
  Association: "关联",
  Enum: "枚举",
  DynamicProp: "动态属性",
  PublicHelp: "公共帮助",
  SystemProcess: "系统处理",
  CreatingTime: "创建时",
  SavingTime: "保存时",
  Geometry: "几何"
}
